var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.b()},[_c('span',[_vm._v("Código de Pago")]),_c('div',{class:_vm.b('code'),on:{"click":_vm.onClickCode}},[_vm._v(_vm._s(_vm.code))])])
}
var staticRenderFns = []

export { render, staticRenderFns }